import { Box, Button, DialogActions, Typography } from '@mui/material';
import React from 'react';
import DefaultModal from '../../../components/Modals/DefaultModal';
import { Company } from '../../../models/company';

interface Props {
  modalData: { open: boolean; company?: Company };
  closeModal: () => void;
  confirmModal: () => void;
}

const ActivateModal = (props: Props): JSX.Element => {
  return (
    <DefaultModal open={props.modalData.open} handleClose={props.closeModal}>
      <Box sx={{ px: 6 }}>
        <Typography variant="h4" textAlign="center" color="grey.900" mb={2}>
          Activate Company
        </Typography>
        <Typography textAlign="center" mb={1}>
          Your about to activate&nbsp;
          <strong>{props.modalData?.company?.name}</strong>
        </Typography>
      </Box>
      <DialogActions sx={{ justifyContent: 'center', py: 3 }}>
        <Button variant="outlined" onClick={props.closeModal}>
          Cancel
        </Button>
        <Button onClick={props.confirmModal}>Yes, Activate Company</Button>
      </DialogActions>
    </DefaultModal>
  );
};

export default ActivateModal;
